export function timeFix() {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 18 ? '下午好' : '晚上好'
}

export function welcome() {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader(callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () {}
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}

export function millsToTime(duration) {
  if (!duration) {
    return ''
  } else if (duration < 1000) {
    var str = ''
    var days = parseInt(duration / (1000 * 60 * 60 * 24));
    var hours = parseInt((duration % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = parseInt((duration % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = parseInt((duration % (1000 * 60)) / (1000));
    var milliseconds = parseInt((duration % 1000))
    var datstr = days ? (days + '天') : '';
    var hoursStr = hours ? (hours + '小时') : '';
    var minstr = minutes ? (minutes + "分钟") : '';
    var secstr = seconds ? (seconds + "秒") : '';
    var milliseconds = milliseconds ? (milliseconds + "毫秒") : '';
    str = datstr + hoursStr + minstr + secstr + milliseconds
    console.log(str)
    return str
  }
  var str = ''
  var days = parseInt(duration / (1000 * 60 * 60 * 24));
  var hours = parseInt((duration % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = parseInt((duration % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = parseInt((duration % (1000 * 60)) / (1000));
  var datstr = days ? (days + '天') : '';
  var hoursStr = hours ? (hours + '小时') : '';
  var minstr = minutes ? (minutes + "分钟") : '';
  var secstr = seconds ? (seconds + "秒") : '';
  str = datstr + hoursStr + minstr + secstr
  console.log(str)
  return str
};

export function compressImg(file, size = 500 * 1024) {
  return new Promise((res, rej) => {
    let reader = new FileReader()
    reader.readAsArrayBuffer(file)
    reader.onload = (e) => {
      let blob = new Blob([e.target.result])
      window.URL = window.URL || window.webkitURL
      let blobUrl = window.URL.createObjectURL(blob)
      let canvas = document.createElement('canvas') // 创建Canvas对象(画布)
      let context = canvas.getContext('2d')
      let oimg = new Image()
      oimg.src = blobUrl // 指定图片的DataURL(图片的base64编码数据)
      oimg.onload = () => {
        let scale = size / file.size
        canvas.width = oimg.width * Math.sqrt(scale)
        canvas.height = oimg.height * Math.sqrt(scale)
        context.drawImage(oimg, 0, 0, canvas.width, canvas.height)
        blobUrl = canvas.toDataURL('image/jpeg')
        console.log(blobUrl);
        let arr = blobUrl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        blobUrl = new Blob([u8arr], {
          type: mime,
          name: file.name,
        })
        console.log(blobUrl);
        res(blobUrl)
      }
    }

  })
}